import Project from "../project/Project";
import PropTypes from "prop-types";
import React from "react";

const MemoizedProject = React.memo(Project);

const ClientDetail = ({ data, employee }) => {
    return (
        <>
            {data.map((project, index) => (
                <MemoizedProject
                     key={employee.userId + "_" + project.jobId}
                     project={project}
                     employee={employee}
                     index={index}
                />
            ))}
        </>
    );
};

ClientDetail.propTypes = {
    data: PropTypes.array.isRequired,
    employee: PropTypes.object.isRequired,
};

export default ClientDetail;